import { createStaleNotice } from '@avrahami/ui';
import { he } from '../i18n/he';

export { useVersionedDraft } from '@avrahami/ui';

/** Says that the data changed elsewhere while this form was being edited, with a reload. */
export const StaleNotice = createStaleNotice(he.common);
